

import React, { memo } from 'react';
import cx from 'classnames';
import { Link as RouterLink } from 'react-router-dom';
import Text from '../../Text';
import './_link.scss';











/**
 * A component to render a link that behaves like a button.
 *
 * @param {LinkProps} props
 *
 * @return {React.Element}
 */
function Link(
{ onClick, children, className, button, to, prefixIcon, buttonProps = {} })
{
  const commonTextProps = {
    link: true,
    prefixIcon,
    prefixIconColor: prefixIcon && 'monkey'
  };

  if (!button && to) {
    return (
      <RouterLink className="link" to={to}>
        <Text className="link__text" {...commonTextProps}>
          {children}
        </Text>
      </RouterLink>);

  }

  return (
    <button
      className={cx('link', 'link--button', className)}
      tabIndex={0}
      type="button"
      onClick={onClick}
      {...buttonProps}>

      <Text {...commonTextProps}>
        {children}
      </Text>
    </button>);

}

export default memo(Link);